/**
 * @file: 鼠标右键菜单
 * @author: xiaolong.huang@dmall.com
 */

import { init } from './init';
import { show, hide } from './toggleMenu';

export default {
    init,
    show,
    hide
}
